<div>
  <div class="sx-error">
    <div class="sx-topheader__logo sx-login__logo"></div>
    <h2>{{'core.error.generic.title' | translate}}</h2>
    <p>{{'core.error.generic.description' | translate}}</p>
    <button class="sx-button sx-button--blue" mat-button routerLink="/">{{'core.error.return' | translate}}</button>
  </div>
</div>